import React, { useMemo } from 'react';
import {
  Select as BaseSelect,
  SelectProps as BaseSelectProps,
} from '@kizi/core-components';

export interface Option {
  label: string;
  value: string | number;
  attrs?: JSX.IntrinsicElements['option'];
}

export interface SelectProps extends BaseSelectProps {
  options: Option[];
}

export const Select: React.FC<SelectProps> = ({ options = [], ...props }) => {
  const _options = useMemo(
    () =>
      options.map((o, i) => (
        <option key={'option-' + i} value={o.value} {...o.attrs}>
          {o.label}
        </option>
      )),
    [options],
  );
  return <BaseSelect {...props}>{_options}</BaseSelect>;
};
